// extracted by mini-css-extract-plugin
module.exports = {"bar":"Bar_bar__3w1E8","bar-fill":"Bar_bar-fill__3OSip","tag":"Bar_tag__3jC38"};